import React from 'react';
import { gql } from '@apollo/client';
import TimestampFields from 'components/TimestampFields';
import { Show, SimpleShowLayout, TextField, ReferenceField } from 'react-admin';

const ContractsShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <ReferenceField reference="assignments" source="assignment_id">
        <TextField source="id" />
      </ReferenceField>
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

ContractsShow.query = gql`
  query GET_ONE($id: Int!) {
    contract(id: $id) {
      id
    }
  }
`;

export default ContractsShow;
